import Vue from 'vue'
import VueRouter from 'vue-router'

import activities from './activity'
import stores from './store'
import util from './util'
import config from '@/config/index'
const layout = () => import(/* webpackChunkName: "index" */ '@/components/layout/index.vue')

const titles = config.isYp ? '邀朋互娱' : '闲逸互娱';

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/activity',
    component: layout,
    meta: { title: '首页', keepAlive: false },
    children: [{
      path: '/activity',
      name: 'activity',
      component: () => import(/* webpackChunkName: "index" */ '@/views/Index/index.vue'),
      meta: { title: titles, keepAlive: false }

    },
    ...activities,
    ...stores,
    ...util
    ]
  },
  {
    path: '/pays',
    name: 'Pays',
    component: () => import('../views/pays.vue'),
    meta: { title: titles, keepAlive: false }
  },
  {
    path: '/paysend',
    name: 'Paysend',
    component: () => import('../views/paysend.vue'),
    meta: { title: titles, keepAlive: false }
  },
  {
    path: '*',
    name: 'About',
    redirect: '/404'
  },
  {
    path: '/404',
    name: 'About',
    component: () => import('../views/404.vue'),
    meta: { title: titles, keepAlive: false }
  },
  {
    path: '/clear',
    name: 'Clear',
    component: () => import('../views/clear.vue'),
    meta: { title: titles, keepAlive: false }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior: () => ({ y: 0 })
})

export default router
